<div class="divide-y divide-gray-300 w-full fiter_cont filter_cont_outer {{filterOpen?'open':'close'}}">

	<div class="scrollable_container">
		<fb-single-filter-config (onControlChange)="onChange()" *ngFor="let control of controls.singleFilterControls"
			[control]="control" class="filter_option"></fb-single-filter-config>

		<fb-nested-filter-config (onControlChange)="onChange()" [control]="controls.nestedControls"
			class="filter_option">
		</fb-nested-filter-config>

		<fb-normal-filter-config (onControlChange)="onChange()" *ngFor="let control of controls.normalFilterControls"
			[control]="control"
			class="filter_option filter_for_{{control.name}} filter_in_searchpage_{{isSearchPage}}">
		</fb-normal-filter-config>

		<fb-color-filter-config (onControlChange)="onChange()" *ngFor="let control of controls.colorFilterControls"
			[control]="control" class="filter_option"></fb-color-filter-config>

		<fb-range-filter-config (onControlChange)="onChange()" *ngFor="let control of controls.rangeFilterControls"
			[control]="control" class="filter_option filter_for_{{control.name}}
			{{isProductsFinished?'for_finished_products':''}}"></fb-range-filter-config>

		<!-- <fb-normal-filter-config (onControlChange)="onChange()" *ngFor="let control of controls.singleFilterControls"
		[control]="control" class="filter_option"></fb-normal-filter-config> -->
		<!-- <div class="" -->
	</div>
<div class="item_count_for_mobile">
	{{productLength}} PRODUCTS
</div>
</div>
<div class="mobile_filter_overlay" (click)="openFilter()" *ngIf="filterOpen"></div>
<button class="filter_trigger_mobile {{filterOpen?'open':'close'}}" (click)="openFilter()">
	<!-- <span class="material-symbols-outlined open">
		filter_alt
	</span> -->
	<span class="mobile_filter_trigger">
		FILTERS
	</span>
	<span class="material-symbols-outlined close">
		close
	</span>
</button>
